"use strict";

var _defineProperty = require("/usr/src/app/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

/* global __PATH_PREFIX__ */
var lunr = require("lunr");
var _require = require("./common.js"),
  enhanceLunr = _require.enhanceLunr;
exports.onClientEntry = function (args, _ref) {
  var languages = _ref.languages,
    _ref$filename = _ref.filename,
    filename = _ref$filename === void 0 ? "search_index.json" : _ref$filename,
    _ref$fetchOptions = _ref.fetchOptions,
    fetchOptions = _ref$fetchOptions === void 0 ? {} : _ref$fetchOptions;
  enhanceLunr(lunr, languages);
  window.__LUNR__ = window.__LUNR__ || {};
  window.__LUNR__.__loaded = fetch("".concat(__PATH_PREFIX__, "/").concat(filename), fetchOptions).then(function (response) {
    return response.json();
  }).then(function (fullIndex) {
    window.__LUNR__ = Object.keys(fullIndex).reduce(function (prev, key) {
      return (0, _objectSpread2.default)({}, prev, _defineProperty({}, key, {
        index: lunr.Index.load(fullIndex[key].index),
        store: fullIndex[key].store
      }));
    }, {
      __loaded: window.__LUNR__.__loaded
    });
    return window.__LUNR__;
  }).catch(function (e) {
    console.log("Failed fetch search index");
    throw e;
  });
};